if(!customElements.get('lumy-review-carousel')){
  class LumyReviewCarousel extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      this.track=this.querySelector('.lumy-feedback-slides');
      this.slides=[...this.querySelectorAll('[data-feedback-slide]')];
      this.dots=[...this.querySelectorAll('[data-feedback-index]')];
      this.active=0;
      this.slides.forEach(slide=>{slide.hidden=false;});
      this.sync(0);
      this.addEventListener('click',event=>{
        const button=event.target.closest('[data-feedback-index]');
        if(button&&this.contains(button))this.show(Number(button.dataset.feedbackIndex));
      },options);
      this.addEventListener('keydown',event=>{
        if(!event.target.closest('[data-feedback-index]'))return;
        let index;
        if(event.key==='ArrowRight')index=this.active+1;
        else if(event.key==='ArrowLeft')index=this.active-1;
        else if(event.key==='Home')index=0;
        else if(event.key==='End')index=this.slides.length-1;
        else return;
        event.preventDefault();
        this.show(index,true);
      },options);
      this.track.addEventListener('scroll',()=>{
        if(this.frame)return;
        this.frame=requestAnimationFrame(()=>{
          this.frame=0;
          const width=this.track.clientWidth;
          if(width)this.sync(Math.round(this.track.scrollLeft/width));
        });
      },{...options,passive:true});
      this.track.addEventListener('pointerdown',event=>{
        if(event.pointerType!=='mouse'||event.button!==0)return;
        this.dragStart={id:event.pointerId,x:event.clientX,left:this.track.scrollLeft,index:this.active,moved:false};
        this.track.setPointerCapture(event.pointerId);
        event.preventDefault();
      },options);
      this.track.addEventListener('pointermove',event=>{
        if(!this.dragStart||event.pointerId!==this.dragStart.id)return;
        const dx=event.clientX-this.dragStart.x;
        if(Math.abs(dx)>5){
          this.dragStart.moved=true;
          this.track.classList.add('is-dragging');
          this.track.scrollLeft=this.dragStart.left-dx;
        }
      },options);
      this.track.addEventListener('pointerup',event=>{
        if(!this.dragStart||event.pointerId!==this.dragStart.id)return;
        const start=this.dragStart,dx=event.clientX-start.x;
        this.dragStart=null;
        this.track.classList.remove('is-dragging');
        if(this.track.hasPointerCapture(event.pointerId))this.track.releasePointerCapture(event.pointerId);
        if(start.moved)this.show(Math.abs(dx)>45?start.index+(dx<0?1:-1):Math.round(this.track.scrollLeft/this.track.clientWidth));
      },options);
      this.track.addEventListener('pointercancel',()=>{
        this.dragStart=null;
        this.track.classList.remove('is-dragging');
      },options);
      this.observer=new ResizeObserver(()=>{
        const width=this.track.clientWidth;
        if(width&&width!==this.width){
          this.width=width;
          this.track.scrollTo({left:this.active*width,behavior:'instant'});
        }
      });
      this.observer.observe(this.track);
    }
    sync(index){
      this.active=Math.max(0,Math.min(this.slides.length-1,index));
      this.slides.forEach((slide,i)=>{slide.setAttribute('aria-hidden',String(i!==this.active));});
      this.dots.forEach((dot,i)=>{
        dot.setAttribute('aria-current',String(i===this.active));
        dot.tabIndex=i===this.active?0:-1;
      });
    }
    show(index,focus=false){
      if(!this.slides.length)return;
      const next=(index+this.slides.length)%this.slides.length;
      this.sync(next);
      this.track.scrollTo({left:next*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      if(focus)this.dots[next]?.focus();
    }
    disconnectedCallback(){
      this.controller?.abort();
      this.controller=null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame=0;
    }
  }
  customElements.define('lumy-review-carousel',LumyReviewCarousel);
}
